import configurationDataServiceFactory from "../../APICalls/configurationDataService.factory";

export default /*@ngInject*/ function (homeDataService, configurationDataService) {

    const vm = this;
    //State
    vm.currentView = 'library'; // 'library' or 'dashboard'
    vm.backToLibrary = backToLibrary;

    // Instance tracking
    vm.libraryInstanceId = null;
    vm.dashboardInstanceId = null;

    vm.accessToken = null;
    vm.setDashboardView = setDashboardView;
    vm.embedManager = null;
    vm.themeId = 'modern';
    vm.riskInsightsSkuEnabled = false;

    async function activate() {
        let authenticateResponse = await homeDataService.authenticateUser();
        vm.accessToken = authenticateResponse.data.Token;

        await getThemes();
        await getSkuEnabled();

        await window.initComposerEmbedManager({ "initialToken": vm.accessToken })
        .then(function (manager) {
            console.log('Embed manager initialized');
            vm.embedManager = manager;
        }).catch(function (err) {
            console.error('Failed to initialize embed manager:', err);
        });

        await setupDashboardLibraryComponent();
    }

    activate();

    async function getSkuEnabled() {
        //if advanced sku, enable create visual on dashboards
        const skus = await configurationDataService.getTenantSkus();
        const riskInsightsSku = skus.data.filter(s => s.SkuName === "Risk Insights");

        if (riskInsightsSku && riskInsightsSku[0] && riskInsightsSku[0].IsEnabled) {
            vm.riskInsightsSkuEnabled = true;
        }
    }

    async function getThemes() {
        const themesUrl = `${logiUrl}discovery/api/customization/themes`;
        const headers = {
            'Accept': 'application/vnd.composer.v3+json',
            'Content-Type': 'application/vnd.composer.v3+json',
            'Authorization': 'Bearer ' + vm.accessToken
        }
        const response = await fetch(themesUrl, { headers });
        const data = await response.json();

        if (data.content) {
            vm.themeId = data.content.filter(d => d.name === 'Delinea')[0].id;
        }
    }

    async function setupDashboardLibraryComponent() {
        vm.currentView = 'library';

        const componentConfig = {
            "inventoryItem": "dashboard",
            "theme": vm.themeId,
            "components": {
                "filters": {
                    "visible": false,
                },
                "search": {
                    "visible": false,
                },
                actions: {
                    visible: true,
                    showDefaults: true,
                    order: ["import-dashboard", "add-new-dashboard"],
                    visibility: ["import-dashboard", "add-new-dashboard"],
                    definitions: [{
                        id: "add-new-dashboard",
                        label: "Create Dashboard",
                        intent: "primary",
                        onClick: async function () {
                            console.log('Create new dashboard clicked');
                            await vm.setDashboardView(null);
                        }
                    }]
                },
                "table": {
                    "defaultSort": {
                        "colId": "name", // ["favorite", "name", "dataSource", "author", "dateModified", "permissions", "schedule", "actions"]
                        "sortDirection": "asc"
                    },

                    "columns": {
                        "showDefaults": true,

                        "order": [
                            "name",
                            "dataSource",
                            "author",
                            "dateModified",
                            "permissions",
                            "schedule",
                            "actions"
                        ],
                        "visibility": [
                            "name",
                            "dataSource",
                            "author",
                            "dateModified",
                            "permissions",
                            "schedule",
                            "actions"
                        ],


                        "definitions": [
                            {
                                colId: "name",
                                cellRendererParams: {
                                    onClick: async function (inventoryItem) {
                                        let dashboardId = inventoryItem.inventoryItemId;
                                        let dashboardName = inventoryItem.name;
                                        console.log('Opening dashboard:', dashboardId, dashboardName);
                                        await vm.setDashboardView(dashboardId);
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            "interactivityOverrides": {
                "name": "interactive",
                "type": "SYSTEM",
                "overrideVisualInteractivity": true,
                "settings": {
                    "DELETE": true,
                    "FILTER": true,
                    "IMPORT": true,
                    "ADD_NEW": true,
                    "PERMISSIONS": true,
                    "MULTI_SELECTION": true,
                    "EXPORT": true,
                    "FAVORITES": false,
                    "DESCRIPTION": true,
                    "TAGS": false,
                    "SCHEDULE": true,
                    "SHARE": true,
                }
            },
        }


        let component = await vm.embedManager.createComponent("inventory", componentConfig);
        vm.libraryInstanceId = component.componentInstanceId;
        await component.render(document.getElementById("library-container"), { width: "100%", height: "100%" });
    }

    async function setDashboardView(dashboardId) {
        vm.currentView = 'dashboard';

        let overrides = {
            "name": "interactive",
            "type": "SYSTEM",
            "overrideVisualInteractivity": true,
            "settings": {
                "REFRESH": true,
                "CHANGE_LAYOUT": true,
                "RENAME": true,
                "SHARE_FILTER_SETS": true,
                "DASHBOARD_INTERACTIONS": true,
                "ADD_TO_FAVORITES": true,
                "DELETE": true,
                "FILTER": true,
                "EXPORT_PNG_PDF": true,
                "ADD_VISUALS": true,
                "EXPORT_CONFIGURATION": true,
                "DASHBOARD_LINKS": true,
                "SAVE": true,
                "SAVE_AS": true,
                "MANAGE_TAGS": false,
                "DASHBOARD_ALERTS": false,
                "SHARE_DASHBOARD": false,
                "SCHEDULE_REPORTS": false,
                "CREATE_TEXT_SNIPPETS": true,
                "CREATE_FILTER_SNIPPETS": true,
                "WIDGET_SETTINGS": true,
                "COMMENTS": true,
                "CREATE_VISUALS": false
            },
            "visualSettings": {
                "ACTIONS_ACTION": true,
                "RULERS": true,
                "ZOOM_ACTION": true,
                "FILTER_ACTION": true,
                "COLORS": true,
                "METRICS": true,
                "ACTIONS": true,
                "TREND_ACTION": true,
                "VISUAL_STYLE": true,
                "KEYSET_ACTION": false,
                "KEYSET": false,
                "COPY": true,
                "SETTINGS": true,
                "EXPORT": true,
                "TIMEBAR_PANEL": true,
                "DETAILS_ACTION": true,
                "MAXIMIZE": true,
                "LINK_ACTION": true,
                "FILTER": true,
                "REMOVE": true,
                "GROUPING": true,
                "RENAME": true,
                "SORT": true,
                "TIMEBAR_FIELD": true,
                "SAVE": false,
                "CONDITIONAL_FORMATTING": true,
                "INFO": true
            }
        };

        //if advanced sku, enable create visual on dashboards
        if (vm.riskInsightsSkuEnabled) {
            overrides.settings.CREATE_VISUALS = "true";
        }

        const componentConfig = {
            "originId": "",
            "dashboardId": dashboardId,
            "interactivityProfileName": "interactive",
            "interactivityOverrides": overrides,
            "theme": vm.themeId,
            "editor": { "placement": "modals" },
            "header": {
                "showActions": true,
                "showTitle": true,
                "visible": true
            }
        };

        let component = await vm.embedManager.createComponent("dashboard", componentConfig);
        vm.dashboardInstanceId = component.componentInstanceId;
        await component.render(document.getElementById("dashboard-container"), { width: "100%", height: "100%" });
        await component.addEventListener('composer-dashboard-saved', async function (event) {
            console.log('Dashboard saved event:', event);
            await vm.embedManager.refreshComponent(vm.libraryInstanceId);
            });
    }
        
    async function backToLibrary() {
        if (vm.dashboardInstanceId) {
            await vm.embedManager.removeComponent(vm.dashboardInstanceId);
        }

        vm.currentView = 'library';
    }
}
